export default __webpack_public_path__ + "static/O7-Brigadier-General-e5c3ac4d07172e08dd42c46a51e01695.png";